<template>
  <!-- Header -->
  <div class="header">
    <!-- Logo -->
    <div class="header-left">
      <router-link to="/" class="logo me-3">
        <img src="@/assets/img/logo/logo.png" alt="Logo" />
      </router-link>
      <span>
        LỊCH HỌP
      </span>

    </div>
    <!-- /Logo -->

  </div>
  <!-- /Header -->
</template>

<script>
export default {
  data() {
    return {
      model: null
    };
  },
  mounted() {

    const auth = localStorage.getItem('auth-user')
    let authParse = JSON.parse(auth)
    if (authParse) {

      this.model = authParse;

    }
    // Add click event listener
    this.$nextTick(() => {
      document.addEventListener("click", this.handleToggleClick);
    });

    // Add mouseover event listener
    document.addEventListener("mouseover", (event) => {
      event.stopPropagation();

      var body = document.body;
      var toggleBtn = document.getElementById("toggle_btn");
      var sidebar = document.getElementsByClassName("sidebar")[0];
      var subdropUL = document.getElementsByClassName("subdrop");

      if (body.classList.contains("mini-sidebar") && toggleBtn.style.display !== "none") {
        var target = event.target.closest(".sidebar");

        if (target) {
          body.classList.add("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "block";
            }
          }
        } else {
          body.classList.remove("expand-menu");
          for (var i = 0; i < subdropUL.length; i++) {
            var ul = subdropUL[i].nextElementSibling;
            if (ul) {
              ul.style.display = "none";
            }
          }
        }

        event.preventDefault();
      }
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleToggleClick);
  },

  methods: {
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      console.log("work")
      var userLocalStorage = localStorage.getItem("auth-user");
      if (userLocalStorage) {
        localStorage.removeItem("userData");
        localStorage.removeItem("auth-user");
        localStorage.removeItem("token");
        let checkTabData = localStorage.getItem("TabData");
        if (checkTabData) {
          localStorage.removeItem("TabData");
        }
        window.location.href = "/"
        return;
      }
    },
    toggleSidebar1() {
      const body = document.body;
      body.classList.toggle("slide-nav");
    },
    toggleSidebar() {
      const body = document.body;
      body.classList.toggle("mini-sidebar");
    },
  },
};
</script>
